import React, { useState } from "react";
import { Progress as AntdProgress } from "antd";
import { useInterval } from "hooks";

/**
 *  Render.
 */
export const Progress = (props) => {
  const [percent, setPercent] = useState(0);

  useInterval(() => {
    if (percent < props.limit) {
      setPercent(percent + 5);
    }
  }, props.interval);

  return (
    <div className="mt-5 w-100 mx-auto">
      <AntdProgress type="circle" percent={percent} />
    </div>
  );
};
